import periodeData from './data/periode.json';

export default enText => {
	const periodeMatched = periodeData.find(
		periode => periode.en_text === enText
	);

	return periodeMatched || {};
};
